import { inject, Injectable } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { lastValueFrom, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { getTranslation } from "../../../utils/i18n.utils";
import { FindOptionsDto } from "../../common/dto/find-options.dto";
import { PromotionConditionTypes } from "../models/promotion-condition-types.model";
import { PromotionConditionTypesApi } from "./promotion-condition-types.api";

@Injectable()
export class PromotionConditionTypesTypeaheadApi extends NiceAsyncTypeaheadProvider<PromotionConditionTypes> {
    private readonly promotionConditionTypesApi = inject(PromotionConditionTypesApi);

    public readonly resource = "promotion-condition-types";

    private readonly pageSize = 20;

    public override async getById(id: number): Promise<PromotionConditionTypes> {
        return lastValueFrom(this.promotionConditionTypesApi.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number
    ): Observable<NiceAsyncTypeaheadSearchResult<PromotionConditionTypes>> {
        const dto: FindOptionsDto = {
            page,
            pageSize: this.pageSize,
            searchQuery
        };

        return this.promotionConditionTypesApi.search(dto).pipe(
            map((items) => ({
                items,
                nextPage: items.length === this.pageSize ? page + 1 : null
            }))
        );
    }

    public override format(item: PromotionConditionTypes): string {
        if (!isPropertyDefined(item, "name")) {
            return "";
        }

        if (typeof item.name === "string") {
            return item.name;
        }

        return getTranslation(item.name) ?? "";
    }
}
